import { render } from "./NavigationWindow.vue?vue&type=template&id=4ccd0572&scoped=true"
import script from "./NavigationWindow.vue?vue&type=script&lang=js"
export * from "./NavigationWindow.vue?vue&type=script&lang=js"

import "./NavigationWindow.vue?vue&type=style&index=0&id=4ccd0572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccd0572"]])

export default __exports__